/** Placeholder credentials until real auth is integrated. */
export const DUMMY_ADMIN_EMAIL = "admin@dominioncity.ie"
export const DUMMY_ADMIN_PASSWORD = "admin123"
export const DUMMY_AUTH_TOKEN = "dummy-admin-session"
export const AUTH_SCOPE_KEY = "auth_scope"
export type AuthScope = "admin" | "chapter-intake"

export const isDummyAuthToken = (token: string | null) => token === DUMMY_AUTH_TOKEN

export const getAuthScope = (): AuthScope | null => {
  const scope = localStorage.getItem(AUTH_SCOPE_KEY)
  return scope === "chapter-intake" ? "chapter-intake" : scope === "admin" ? "admin" : null
}

export const setAuthSession = (token: string, scope: AuthScope = "admin") => {
  localStorage.setItem("auth_token", token)
  localStorage.setItem(AUTH_SCOPE_KEY, scope)
}

export const validateDummyCredentials = (email: string, password: string) =>
  email.trim().toLowerCase() === DUMMY_ADMIN_EMAIL && password === DUMMY_ADMIN_PASSWORD

export const setDummyAdminSession = () => {
  setAuthSession(DUMMY_AUTH_TOKEN, "admin")
}

export const clearAdminSession = () => {
  localStorage.removeItem("auth_token")
  localStorage.removeItem(AUTH_SCOPE_KEY)
}
